import { Above } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import React, { Component } from 'react';
import FilterDrawer from './FilterDrawer';
import FilterButton from './Mobile/FilterButton';

class Filter extends Component {
  render() {
    const { filters } = this.props;
    const sortOrders = this.props?.sortOrders ?? [];
    const search = this.props?.search;
    const totalProducts = this.props?.totalProducts;

    return (
      <>
        <DrawerTrigger id="filterDrawer">
          {({ showTarget }) => (
            <FilterButton
              showTarget={showTarget}
              filters={filters}
              search={search}
            />
          )}
        </DrawerTrigger>
        <DrawerTarget id="filterDrawer">
          {({ hideTarget, isOpen }) => (
            <>
              <Above breakpoint="lg">
                {(matches) => (
                  <Drawer isOpen={isOpen} left size={matches ? 500 : 360}>
                    <FilterDrawer
                      close={hideTarget}
                      filters={filters}
                      sortOrders={sortOrders}
                      totalProducts={totalProducts}
                    />
                  </Drawer>
                )}
              </Above>
            </>
          )}
        </DrawerTarget>
      </>
    );
  }
}

export default Filter;
